import React from 'react';

function SurveysPagination({currentPage, lastPage, changePageFunction}) {
    let pageArrayFirstHalf = [];
    let pageArraySecondHalf = [];

    if (currentPage < 5) for (var i = 1; i < currentPage; i++) pageArrayFirstHalf.push(i);
    else pageArrayFirstHalf = pageArrayFirstHalf.concat([1, "...", currentPage-1]);
    if (currentPage < lastPage){
        if(lastPage - currentPage < 4) for (var i = currentPage+1; i <= lastPage; i++) pageArraySecondHalf.push(i);
        else pageArraySecondHalf = pageArraySecondHalf.concat([currentPage+1, "...", lastPage])
    }

    const pageMappingFunction = (page, index) => {
        return <a key={"surveys_page_button_key_" + index}
                  className="pagination__list__item"
                  onClick={() => page !== "..." && changePageFunction(page)}>
            {page}
        </a>;
    };

    return (
        <div className="pagination">
            <div className="pagination__list">
                <a className="pagination__list__item pagination__list__item--pagination">
                    <img src="assets/img/surveys/pagination-left.png" alt=""/>
                </a>
                {pageArrayFirstHalf.map(pageMappingFunction)}
                <a className="pagination__list__item pagination__list__item--active">{currentPage}</a>
                {pageArraySecondHalf.map(pageMappingFunction)}
                <a className="pagination__list__item pagination__list__item--pagination">
                    <img src="assets/img/surveys/pagination-right.png" alt=""/>
                </a>
            </div>
        </div>
    );
}

export default SurveysPagination;